import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Avatar from '@material-ui/core/Avatar';
import { Card, CardContent, Container, Grid, TextField, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import { setCustomerDetails } from '../../redux/actions/customerAction';
import HttpService from '../../services/httpService';
import { referalPolicy } from '../../utils';

const useStyles = makeStyles((theme) => ({
  // Your existing styles...

  // Add new styles for the buttons
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(2),
    flexWrap: 'wrap', // Allow items to wrap to the next line
  },
  button: {
    width: '48%', // Adjust the width as needed
    marginBottom: theme.spacing(2),
    whiteSpace: 'nowrap',
    textTransform: 'none',
    overflow: 'hidden',        // Hides overflowing content
    textOverflow: 'ellipsis',  // Adds "..." if text overflows
    maxWidth: '100%',          // Prevents button from expanding too far
    minWidth: '150px', 
    padding: '8px 16px',
    minWidth: '360px',  // Adjust based on longest button label
    maxWidth: '360px',
    width: 'fit-content',        
    [theme.breakpoints.down('sm')]: {
      width: '100%', // Full width on small screens
    },
  },
}));

const CustomerDownloadCenter = () => {
  const classes = useStyles();
  const { customerDetails } = useSelector((state) => state.customer);
  const [customerQuotation,setCustomerQuotation] = useState([])
  const [otherAttahcments,setOtherAttachments] = useState([])


  const getCustomerQuotation = async () => {
    try {

      let res = await HttpService.getCustomerQuotation(customerDetails.leadId);
      setCustomerQuotation(res.data);
    } catch (error) {
      console.error("Token not available.");
    }
  };

  const getCustomerDetails = async () => {
    try {
      let res = await HttpService.getCustomerDetails(customerDetails._id);
      setOtherAttachments(res.data.leadDetails);
    } catch (error) {
      console.error("Token not available.");
    }
  };


  const handleQuotation = () =>{
    window.open(customerQuotation)
  }

  const handleLeadAttachment = (e) =>{
    if (e.currentTarget.getAttribute('data-value') === "sales") {
      window.open(otherAttahcments.salesChecklistPdfFile)
    }
    else if (e.currentTarget.getAttribute('data-value') === "salesquotation") {
      window.open(otherAttahcments.salesQuotation)
    }
    else if (e.currentTarget.getAttribute('data-value') === "designQuotation") {
      window.open(otherAttahcments.scanQuotationFile)
    }
  else if(e.currentTarget.getAttribute('data-value') === "contactdoc"){
    window.open(otherAttahcments.customerAgreementPdf || otherAttahcments.termsAndConditionsPdf)
  }
  else if(e.currentTarget.getAttribute('data-value') === "scanProjectKickOffCheckListFile"){
    window.open(otherAttahcments.scanProjectKickOffCheckListFile)
  }
  else if(e.currentTarget.getAttribute('data-value') === "scanSiteQCCheckListFile"){
    window.open(otherAttahcments.scanSiteQCCheckListFile)
  }
  else if(e.currentTarget.getAttribute('data-value') === "workingDrawingFile"){
    window.open(otherAttahcments.workingDrawingFile)
  }
  else if(e.currentTarget.getAttribute('data-value') === "3DworkingDrawingFile"){
    window.open(otherAttahcments.ThreeDworkingDrawingFile)
  }
  else if(e.currentTarget.getAttribute('data-value') === "electroDomesticChecklistfile"){
    window.open(otherAttahcments.finalizationOfMaterialCheckListPdf)
  }
  else if(e.currentTarget.getAttribute('data-value') === "completionCertificate"){
    window.open(otherAttahcments.completionCertificate)
  }
  else if(e.currentTarget.getAttribute('data-value') === "referalPolicy"){
    window.open(referalPolicy?.url)
  }
  }
  useEffect(()=>{
    getCustomerDetails();
    getCustomerQuotation();
  },[])

  return (
    <Container maxWidth="md" style={{ marginTop: '7rem', marginBottom: '8rem' }}>
  <Card>
    <CardContent>
      <div style={{ display: 'flex', gap: '2rem' }}>
        {/* Column 1 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', flex: 1 }}>
          {/* <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="salesquotation" onClick={handleLeadAttachment} disabled={!otherAttahcments.salesQuotation}>
            Download Sales Quotation
          </Button> */}
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="sales" onClick={handleLeadAttachment} disabled={!otherAttahcments.salesChecklistPdfFile}>
            Download Sales Checklist
          </Button>
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="contactdoc" onClick={handleLeadAttachment} disabled={!otherAttahcments.customerAgreementPdf && !otherAttahcments.termsAndConditionsPdf}>
            Download Contract Document
          </Button>
          {/* <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="designQuotation" onClick={handleLeadAttachment} disabled={!otherAttahcments.scanQuotationFile}>
            Download Design Quotation
          </Button> */}
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="scanProjectKickOffCheckListFile" onClick={handleLeadAttachment} disabled={!otherAttahcments.scanProjectKickOffCheckListFile}>
            Download Project Kick Off Checklist
          </Button>
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="scanSiteQCCheckListFile" onClick={handleLeadAttachment} disabled={!otherAttahcments.scanSiteQCCheckListFile}>
            Download Site QC File
          </Button>
        </div>

        {/* Column 2 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', flex: 1 }}>
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="workingDrawingFile" onClick={handleLeadAttachment} disabled={!otherAttahcments.workingDrawingFile}>
            Download Working Drawing
          </Button>
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="3DworkingDrawingFile" onClick={handleLeadAttachment} disabled={!otherAttahcments.workingDrawingFile}>
            Download 3D Working Drawing
          </Button>
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="electroDomesticChecklistfile" onClick={handleLeadAttachment} disabled={!otherAttahcments.finalizationOfMaterialCheckListPdf}>
            Download Electro-Domestic Checklist
          </Button>
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="completionCertificate" onClick={handleLeadAttachment} disabled={!otherAttahcments.completionCertificate}>
            Download Completion Certificate
          </Button>
          <Button className={classes.button} fullWidth variant="contained" color="primary" data-value="referalPolicy" onClick={handleLeadAttachment}>
            Download Referral Policy
          </Button>
        </div>
      </div>
    </CardContent>
  </Card>
</Container>
  
  );
};

export default CustomerDownloadCenter;